import { Link, useParams, Navigate } from "react-router-dom";
import { SERVICES } from "../data/site";
import SectionHeader from "../components/SectionHeader";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);
  if (!service) return <Navigate to="/services" replace />;

  return (
    <>
      <section className={`${service.bg} pt-16 pb-20`}>
        <div className="container-st grid lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-blue-700">Services</p>
            <h1 className="mt-3 text-5xl sm:text-6xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
              {service.title}
            </h1>
            <p className="mt-5 text-lg text-slate-700 max-w-xl leading-relaxed">{service.short}</p>
            <Link
              to="/contact?type=quote"
              data-testid="service-cta-quote"
              className="mt-8 inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3.5 rounded-full"
            >
              Get a Job Quote <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-3xl p-8 shadow-sm border border-white/60"
          >
            <h3 className="text-xl font-semibold text-slate-900">What's included</h3>
            <ul className="mt-5 space-y-3">
              {service.deliverables.map((d) => (
                <li key={d} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 mt-0.5" />
                  <span className="text-slate-700">{d}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </section>

      <section className="container-st section-pad">
        <SectionHeader
          eyebrow="Process"
          title="How an engagement typically runs"
          subtitle="A four-phase rhythm that keeps stakeholders close and momentum high."
        />
        <div className="grid md:grid-cols-4 gap-6 mt-12">
          {[
            { t: "1. Discover", d: "Stakeholder interviews and audit." },
            { t: "2. Design", d: "UX, architecture, and delivery plan." },
            { t: "3. Build", d: "Two-week sprints with weekly demos." },
            { t: "4. Launch", d: "Ship, monitor, and continuously improve." },
          ].map((p) => (
            <div key={p.t} className="rounded-3xl bg-white border border-slate-100 p-6">
              <div className="text-blue-700 font-mono text-xs tracking-widest">PHASE</div>
              <h4 className="mt-2 text-lg font-semibold text-slate-900">{p.t}</h4>
              <p className="mt-2 text-sm text-slate-600">{p.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/services" className="text-blue-700 font-semibold">
            ← All services
          </Link>
        </div>
      </section>
    </>
  );
}
